import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";
import { observer } from "mobx-react-lite";
import { DataImportObservable } from "@/store/data-imports/DataImportObservable";
import styled from "@emotion/styled";

interface Props {
  dataImport: DataImportObservable;
}

export const DataImportStatusIndicator = observer(({ dataImport }: Props) =>
  dataImport.isRunning ? (
    <MdsIcon kind={MdsIconKind.SpinnerSolid} />
  ) : dataImport.endedWithError ? (
    <StyledFailureIcon kind={MdsIconKind.Danger} />
  ) : (
    <StyledSuccessIcon kind={MdsIconKind.CheckCircleSolid} />
  )
);

const StyledSuccessIcon = styled(MdsIcon)`
  color: ${({ theme }) => theme.colors.text.positive};
`;

const StyledFailureIcon = styled(MdsIcon)`
  color: ${({ theme }) => theme.colors.text.negative};
`;
